import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import UsageHistoryForm from '../UsageHistoryForm/UsageHistoryForm';
import { ANONYMIZED, ExtraFeatureT } from '../ModuleForm/helpers/definitions';
import { Checkbox, FormControlLabel } from '@mui/material';

type AnonymizedFormProps = {
    extraFeatures: ExtraFeatureT[];
    setExtraFeatures: (extraFeatures: ExtraFeatureT[]) => void;
};

type Props = {
    usageHistory: boolean;
    setUsageHistory: (usageHistory: boolean) => void;
} & AnonymizedFormProps;

const AnonymizedForm = ({
    extraFeatures,
    setExtraFeatures,
}: AnonymizedFormProps) => {
    const { t } = useTranslation();
    const checked = extraFeatures.includes(ANONYMIZED);
    const setAnonymizes = () => {
        const cleanFeatures = extraFeatures.filter((f) => f !== ANONYMIZED);
        setExtraFeatures(
            checked ? cleanFeatures : [...cleanFeatures, ANONYMIZED],
        );
    };

    return (
        <FormControlLabel
            label={t('extraFeatures.anonymized')}
            control={<Checkbox checked={checked} onChange={setAnonymizes} />}
        />
    );
};

const CoreForm = ({
    usageHistory,
    setUsageHistory,
    extraFeatures,
    setExtraFeatures,
}: Props) => {
    const { t } = useTranslation();
    return (
        <>
            <Typography variant="h4">
                {t('support.clientConfiguration.core')}
            </Typography>
            <UsageHistoryForm
                usageHistory={usageHistory}
                setUsageHistory={setUsageHistory}
            />
            <AnonymizedForm
                extraFeatures={extraFeatures}
                setExtraFeatures={setExtraFeatures}
            />
        </>
    );
};

export default CoreForm;
